import React from "react";
import { useLocation } from "react-router-dom";

type RoleToggleProps = {
  options: string[];
  active: string;
  onChange: (value: string) => void;
  activeClassName?: string;   // optional override
  inactiveClassName?: string; // optional override
  containerClassName?: string; // optional override for parent div
};

const RoleToggle: React.FC<RoleToggleProps> = ({
  options,
  active,
  onChange,
  activeClassName = "bg-[#303030] text-white", // default values
  inactiveClassName = "bg-transparent text-[#212121]/70",
  containerClassName = "inline-flex rounded-full bg-white border border-[#D8D8D8] py-0.5 px-1 space-x-2",
}) => {
  const location = useLocation();

  const handleClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    option: string
  ) => {
    // Allow Ctrl+Click or Cmd+Click to open in new tab
    if (e.metaKey || e.ctrlKey) return;

    e.preventDefault();
    onChange(option);
  };

  return (
    <div className={containerClassName} role="group">
      {options.map((option) => {
        const href = `${location.pathname}?tab=${encodeURIComponent(option)}`;
        return (
          <a
            key={option}
            href={href} // 👈 real link → right-click "open in new tab" works
            onClick={(e) => handleClick(e, option)}
            className={`px-4 py-2 text-sm rounded-full transition-colors duration-200 ${
              active === option ? activeClassName : inactiveClassName
            }`}
          >
            {option}
          </a>
        );
      })}
    </div>
  );
};

export default RoleToggle;
